// extracted by mini-css-extract-plugin
export default {"outerDiv":"units-page_outerDiv__WYaHx","cardOuterDiv":"units-page_cardOuterDiv__POF3X","cNameText":"units-page_cNameText__8utP0","cDescText":"units-page_cDescText__gZkKy"};